(() => {
  if (window.osProductLayoutInstalled) return;
  window.osProductLayoutInstalled = true;
  if (!customElements.get('os-product-gallery')) {
    customElements.define('os-product-gallery', class extends HTMLElement {
      connectedCallback() {
        this.layout = this.closest('.os-product-layout');
        this.update = () => {
          const offset = parseFloat(getComputedStyle(this.layout).getPropertyValue('--os-gallery-offset')) || 0;
          this.style.setProperty('--os-gallery-top', Math.min(offset, innerHeight - this.getBoundingClientRect().height - 16) + 'px');
        };
        this.resize = new ResizeObserver(this.update);
        this.resize.observe(this);
        window.addEventListener('resize', this.update);
        this.update();
      }
      disconnectedCallback() { this.resize?.disconnect(); window.removeEventListener('resize', this.update); }
    });
  }
  function enhance(root = document) {
    root.querySelectorAll('.os-product-layout .t4s-swatch').forEach(swatch => {
      if (swatch.dataset.osAccessible) return;
      swatch.dataset.osAccessible = 'true';
      const update = () => swatch.querySelectorAll('button[data-swatch-item]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.classList.contains('is--selected')));
        button.setAttribute('aria-disabled', String(button.classList.contains('is--unavailable') || button.classList.contains('is--soldout')));
      });
      update();
      const observer = new MutationObserver(update);
      observer.observe(swatch, {subtree:true, attributes:true, attributeFilter:['class']});
      swatch.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => observer.disconnect(), {once:true});
    });
  }
  enhance();
  document.addEventListener('shopify:section:load', e => enhance(e.target));
})();
